import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getStartJobList = createAsyncThunk(
  "startJobList/getStartJobList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/start_booking`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const startJobSlice = createSlice({
  name: "startJobList",
  initialState: {
    loading: false,
    startJobData: null,
    error: null,
  },
  reducers: {
    ResetStartJob: (state) => {
        state.startJobData = null; // Clear old data
        state.loading = true;
      },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStartJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStartJobList.fulfilled, (state, action) => {
        state.loading = false;
        state.startJobData = action.payload;
      })
      .addCase(getStartJobList.rejected, (state, action) => {
        state.loading = false;
        state.startJobData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetStartJob } = startJobSlice.actions;
export default startJobSlice.reducer;
